import axios from 'axios'
import { useSession } from '@/composables/useSession'

const isDevelopment = process.env.NODE_ENV === 'development'
const apiKey = isDevelopment
  ? process.env.VUE_APP_DEV_API_KEY
  : process.env.VUE_APP_PROD_API_KEY
const baseURL = isDevelopment
  ? process.env.VUE_APP_DEV_BASE_URL
  : process.env.VUE_APP_PROD_BASE_URL

export const openPayConfig = {
  merchantId: isDevelopment
    ? process.env.VUE_APP_OPENPAY_MERCHANT_ID
    : process.env.VUE_APP_OPENPAY_PROD_MERCHANT_ID,
  publicApiKey: isDevelopment
    ? process.env.VUE_APP_OPENPAY_PUBLIC_API_KEY
    : process.env.VUE_APP_OPENPAY_PROD_PUBLIC_API_KEY,
  sandboxMode: process.env.VUE_APP_OPENPAY_SANDBOX_MODE,
}

export const client = axios.create({
  baseURL,
  headers: { 'x-api-key': apiKey },
})

client.interceptors.request.use(
  async (config) => {
    // 1) Si esta petición es de REFRESH_TOKEN, o viene marcada, la dejamos pasar

    if (config.url.includes('bucket')) {
      return config
    }
    if (config.url.includes('auth/refresh_token')) {
      return config
    }

    const { token, isPublicUser, refreshAccessTokenIfNeeded, logout } = useSession()

    // 2) Sin token => nada que hacer
    if (!token.value) {
      return config
    }

    // 3) Usuario público => solo adjuntar token
    if (isPublicUser.value) {
      config.headers.Authorization = `Bearer ${token.value}`
      return config
    }

    // 4) Para el resto, intentamos refrescar si hace falta
    const newToken = await refreshAccessTokenIfNeeded()
    if (!newToken) {
      logout()
      return Promise.reject('No se pudo refrescar el token. Se forzó logout.')
    }

    config.headers.Authorization = `Bearer ${newToken}`
    return config
  },
  (error) => Promise.reject(error)
)
